import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { DashboardComponent } from '../calculate/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'app',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: '/app/main', pathMatch: 'full' },
      { path: 'main', component: DashboardComponent },
      { path: 'calculate', loadChildren: '../calculate/calculate.module#CalculateModule' }
    ]
  },
];

export const LayoutRoutingModule = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/layout-routing.module.ts